import { Autocomplete, Box, Button, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Skeleton, Switch, TextField, Typography } from '@mui/material';
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React, { useEffect, useRef, useState } from 'react'
import { ApiBloomsPDF, ApiGetAreaManager, ApiGetMonthlyComparison, ApiGetNewClientPdf, ApiGetNewVenuePdf, ApiGetVenueList, ApiMonthlyReport, ApiMonthlyvenue, ApiRegionVenues } from '../../apiService/Core/Apicall';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import storage from '../../utils/storage';
import { hideLoading, showLoading } from '../../global/config/Reducer/loadingSlice';



pdfjs.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.js';
function MonthlyPdf() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const loading = useSelector((state: any) => state.loader.isLoading);
    const dispatch = useDispatch()
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [monthlyreportyear, setmonthlyreportyear] = useState<any>(dayjs(selectedMonth))
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const isTransport = storage.getItem('ClientGroupName')
    const [venuelist, setvenuelist] = useState<any[]>([])
    const [venues, setvenues] = useState<number | string>('')
    const [area, setSelectedArea] = useState<number | string | null>(null)
    const [Areamanagerlist, setareamanagerlist] = useState<any[]>([])
    const Regions = useSelector(RegionList)
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const [showLoading, setShowLoading] = useState(false)

    //   const ref = useRef();




    const downloadMonthlyReport = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;
        const data2 = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}&type=comparisonDownload${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;
        const data3 = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;

         setShowLoading(true)
        try {
            const response = (isTransport === 'TRANSPORT') ? await ApiGetMonthlyComparison(data2) : (isTransport === 'BLOOMS') ? (storage.getItem('userRole') === 'clientadmin' || storage.getItem('userRole') === 'areaManager') ? await ApiBloomsPDF(data3) : await ApiMonthlyvenue(data3) : await ApiMonthlyReport(data);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            // toast.error("Failed to load PDF: " + error);
        }
        finally {
            setShowLoading(false)
        }
    };

    const ViewVeueReport = async () => {
        // if(!venues){
        //     toast.error("Please Select a Venue")
        //     return
        // }
        setShowLoading(true)
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;
        try {
            console.log("Before APi call", new Date().getMinutes, new Date().getSeconds)
            const response = await ApiGetNewVenuePdf(data);
            console.log("Aftre APi call", new Date().getMinutes, new Date().getSeconds)
            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            // toast.error("Failed to load PDF: " + error);
        }
        finally {
            setShowLoading(false)
        }
    };

    const ViewClientReport = async () => {
        setPdfUrl(null)
        // if(!venues){
        //     toast.error("Please Select a Venue")
        //     return
        // }
        setShowLoading(true)
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`;
        try {
            console.log("Before APi call", new Date().getMinutes, new Date().getSeconds)
            const response = await ApiGetNewClientPdf(data);
            console.log("Aftre APi call", new Date().getMinutes, new Date().getSeconds)
            // dispatch(showLoading())
            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            toast.error("Data not Found");
        }
        finally {
            setShowLoading(false)
        }
    };

    const handleDownloadPdf = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;
        const data2 = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}&type=comparisonDownload${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;
        const data3 = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;


        try {
            const response = (isTransport === 'TRANSPORT') ? await ApiGetMonthlyComparison(data2) : (isTransport === 'BLOOMS') ? (storage.getItem('userRole') === 'clientadmin' || storage.getItem('userRole') === 'areaManager') ? await ApiBloomsPDF(data3) : await ApiMonthlyvenue(data3) : await ApiMonthlyReport(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });


            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const venueName = venuelist?.find((item) => item?.venueId == venues)
            // 🔥 Auto Download Code
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            // Set filename (customizable)
            const fileName = `Monthly_Report_${venues ? venueName?.venueName?.toString() : storage.getItem('clientEntityName') ? storage.getItem('clientEntityName') : ''}_${monthlyreportyear.month() + 1}_${monthlyreportyear.year()}.pdf`;

            link.href = url;
            link.download = fileName;
            link.click();

            URL.revokeObjectURL(url);
        } catch (error: any) {
            // toast.error("Failed to load PDF: " + error);
        }
    };

    const handleDownloadPdf2 = async () => {
        // if(!venues){
        //     toast.error("Please Select a Venue")
        //     return
        // }
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${venues ? `&venueId=${venues}` : ''}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}${storage.getItem('userRole') === 'clientadmin' && venues ? `&isVenueVisibleToClient=true` : ''}`;

        try {
            const response = await ApiGetNewVenuePdf(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const venueName = venuelist?.find((item) => item?.venueId == venues)
            // 🔥 Auto Download Code
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            // Set filename (customizable)
            const fileName = `Monthly_Report_${venues ? venueName?.venueName?.toString() : storage.getItem('clientEntityName') ? storage.getItem('clientEntityName') : ''}_${monthlyreportyear.month() + 1}_${monthlyreportyear.year()}.pdf`;

            link.href = url;
            link.download = fileName;
            link.click();

            URL.revokeObjectURL(url);
        } catch (error: any) {
            // toast.error("Failed to load PDF: " + error);
        }
    };
    const handleDownloadClientPdf = async () => {
        // if(!venues){
        //     toast.error("Please Select a Venue")
        //     return
        // }
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`;

        try {
            const response = await ApiGetNewClientPdf(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const venueName = venuelist?.find((item) => item?.venueId == venues)
            // 🔥 Auto Download Code
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            // Set filename (customizable)
            const fileName = `Monthly_Report_${venues ? venueName?.venueName?.toString() : storage.getItem('clientEntityName') ? storage.getItem('clientEntityName') : ''}_${monthlyreportyear.month() + 1}_${monthlyreportyear.year()}.pdf`;

            link.href = url;
            link.download = fileName;
            link.click();

            URL.revokeObjectURL(url);
        } catch (error: any) {
            // toast.error("Failed to load PDF: " + error);
        }
    };

    useEffect(() => {
        if (!monthlyreportyear) return;
        const timeout = setTimeout(() => {
            if (storage.getItem('userRole') === 'venueadmin' || venues) {
                isTransport !== 'TRANSPORT' ? ViewVeueReport() : downloadMonthlyReport()
            }
            // else if(storage.getItem('userRole') === 'clientadmin'){
            // }
            else {
                isTransport !== 'TRANSPORT' ? ViewClientReport() : downloadMonthlyReport();
                // downloadMonthlyReport();
            }
        }, 300);

        return () => clearTimeout(timeout);
    }, [monthlyreportyear, venues, clientEntity, area, isGroupScore])

    useEffect(() => {
        return () => {
            if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        };
    }, [pdfUrl]);

    useEffect(() => {
        setmonthlyreportyear(dayjs(selectedMonth))
    }, [selectedMonth])


    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0 && !selectedRegion) {
            setselectedRegion(Regions[0].regionId);
            setvenuelist(Regions[0].venues)
            // setvenues(Regions[0].venues[0].venueId)
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const Venuelist = async () => {
            if (!window.location.hostname.includes('aldi')) {
                try {
                    const clientEntityId: any = isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')
                    const response = await ApiGetVenueList(clientEntityId);
                    console.log(response)
                    setvenuelist(response.data);
                    if (response.data.length > 0) {
                        // setvenues(response.data[0].venueId)
                    }
                } catch (error: any) {
                    // toast.error(error)
                }
            }
            else {
                const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                setvenuelist(finalregion)
                if (finalregion && finalregion.length > 0) {
                    // setvenues(finalregion[0].venueId)
                }

            }

        };
        Venuelist();
        clientEntity && fetchAreaManagers()

    }, [selectedRegion, clientEntity, isGroupScore])

    const fetchAreaManagers = async () => {
        try {
            const data = `?offset=0&limit=1000&clientEntityId=${isGroupScore ? clientEntityIds : clientEntity}`
            const response = await ApiGetAreaManager(data)
            setareamanagerlist(response.data)
        } catch (error) {
            console.error('Error fetching area managers:', error)
        }
    }
    return (
        <Box>
            <Box maxWidth='100%' display={{ xs: "flex", md: "none" }} className='justify-content-end select-range white-select align-items-center gap-5'>
                {window.location.hostname.includes('aldi') && (
                    <FormControl sx={{ width: 'fit-content', minWidth: '100px' }}>
                        <InputLabel id="demo-simple-select-label" shrink={false}>Region: &nbsp;</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={Regions[0]?.regionId}
                            value={selectedRegion}
                            onChange={(e) => { setselectedRegion(e.target.value) }}
                        >
                            {Regions?.map((item: any, index: number) => (
                                <MenuItem key={index} value={item.regionId}>
                                    {item.regionName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                <FormControl sx={{ width: 'fit-content', minWidth: '100px' }}>
                    <InputLabel id="demo-simple-select-label" shrink={false}>Sites:</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={venues}
                        onChange={(e) => { setvenues(e.target.value) }}
                    >
                        {venuelist?.map((item: any, index: number) => (
                            <MenuItem key={index} value={item.venueId}>
                                {item.venueName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

            </Box>
            <Box className='mt-3 d-flex align-items-center justify-content-between mb-3'>
                <Typography className='fw-bold' variant='h6'>Monthly Presentation</Typography>
                {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") === "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                    <Box>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isGroupScore}
                                    onChange={(e) => { setSelectedArea(null); setisGroupScore(e.target.checked) }}
                                />
                            }
                            label={"Whole Group"}
                        />
                    </Box>)}
                <Box className='d-flex align-items-center gap-2 justify-content-end flex-wrap'>
                    {/* <Button className='button-primary' onClick={() => { ViewVeueReport() }}>View Venue Pdf</Button> */}
                    {/* <Button className='button-primary' onClick={() => { handleDownloadPdf2() }}>Download Venue Pdf</Button> */}
                    {/* <Button className='button-primary' onClick={() => { handleDownloadPdf() }}>Download</Button> */}
                    {isTransport === 'TRANSPORT' ? (
                        <Button className='button-primary' onClick={() => { handleDownloadPdf() }}>Download</Button>
                    ) : (
                        <Button className='button-primary' onClick={() => { (storage.getItem('userRole') === 'venueadmin' || venues) ? handleDownloadPdf2() : handleDownloadClientPdf() }}>Download</Button>
                    )}
                    <Box display={{ xs: "none", md: 'flex' }} className='pe-3 justify-content-between align-items-center' gap={{ xs: 5, lg: 2 }}>
                        {window.location.hostname.includes('aldi') && (
                            <FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                                <Autocomplete
                                    options={Regions || []}
                                    getOptionLabel={(option) => option.regionName || ''}
                                    value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                    onChange={(event, newValue) => {
                                        setselectedRegion(newValue?.regionId || '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Region"
                                            variant="outlined"
                                            sx={{ input: { color: 'black' } }} // Ensures text is visible
                                        />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                                />
                            </FormControl>
                        )}
                        {storage.getItem('userRole') === 'clientadmin' && storage.getItem('ClientGroupName') !== "ALDI" && (
                            <FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                                {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                                <Autocomplete
                                    className='text-dark'
                                    options={Areamanagerlist || []}
                                    disabled={isGroupScore}
                                    getOptionLabel={(option) => option?.areaName || ''}
                                    value={Areamanagerlist?.find((item) => item.areaId === area) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedArea(newValue?.areaId || '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Area" sx={{ color: 'black !important' }} variant="outlined" />
                                    )}

                                    isOptionEqualToValue={(option, value) => option.areaId === value.areaId}
                                />
                            </FormControl>
                        )}
                        <FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                            {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                            <Autocomplete
                                className='text-dark'
                                options={venuelist || []}
                                getOptionLabel={(option) => option.venueName || ''}
                                value={venuelist?.find((item) => item.venueId === venues) || null}
                                onChange={(event, newValue) => {
                                    setvenues(newValue?.venueId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Sites" sx={{ color: 'black !important' }} variant="outlined" />
                                )}

                                isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
                            />
                        </FormControl>
                    </Box>
                    <Box width={{ xs: '75%', md: 'fit-content' }} maxWidth='170px' className='d-flex align-items-center justify-content-end'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker value={monthlyreportyear}
                                sx={{ justifyContent: 'end' }}
                                label='Month: '
                                views={['month', 'year']}
                                format="MMM-YY"
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }}

                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </LocalizationProvider>
                    </Box>
                </Box>
            </Box>
            {/* <Box className='d-flex justify-content-end my-1 mb-2'>
            </Box> */}

            {pdfUrl && (
                // <Document
                //     file={`/proxy-pdf?url=https://external.com/sample.pdf`}
                //     onLoadError={(error) => console.error('PDF load error:', error)}
                //     onSourceError={(error) => console.error('Source error:', error)}
                // >
                //     <Page pageNumber={1} />
                // </Document>

                <iframe
                    src={pdfUrl + "#toolbar=0"}
                    title="Monthly Report PDF"
                    width="100%"
                    height="700px"
                    style={{ border: 'none' }}
                />
            )}
            {!loading && showLoading && (
                <div
                    className='loader-overlay'
                // style={{ display: `${loader ? 'flex' : 'none'}` }}
                >
                    <div className='spinner'>
                        <div className='clip-loader'></div>
                    </div>
                </div>
                // <Skeleton variant="rounded" width={"100%"} height={700} />
            )}
        </Box>
    )
}

export default MonthlyPdf
